import { V1Request } from '~utils/apiRequest';

// Note that we try very hard to return true from this.  This is because a return of false
// will trigger an alert that push token is invalid, and that in order to receive push
// notifications, the user must uninstall/reinstall the app.  We do not want to alert the
// user of this unecessarily, so only if we are absolutely sure the token is invalid do we return false.
// We don't want to return false on a bad request/response, or anything like that.  Only when server
// responds that token is invalid.  This should rarely happen if ever.

const useExpoPushTokenRefresh = async (pushToken) => {
	if (!pushToken) return true;
	const response = await V1Request(
		'post',
		`ValidatePushToken?pushToken=${pushToken}`,
		null,
		null,
		'json',
		null
	);
	if (response?.data?.success === false) {
		return false;
	}
	return true;
};

export default useExpoPushTokenRefresh;
